(function initPhoneValidation(global) {
  function normalizeAustralianPhoneNumber(value) {
    let phone = String(value || '').trim().replace(/[\s().-]/g, '');

    if ( phone.startsWith('+610') ) {
      phone = `0${phone.slice(4)}`;
    } else if ( phone.startsWith('+61') ) {
      phone = `0${phone.slice(3)}`;
    } else if ( phone.startsWith('61') ) {
      phone = `0${phone.slice(2)}`;
    }

    return phone;
  }

  function isValidAustralianPhoneNumber(value) {
    const phone = normalizeAustralianPhoneNumber(value);
    return /^04\d{8}$/.test(phone) || /^0[2378]\d{8}$/.test(phone);
  }

  const helpers = {
    isValidAustralianPhoneNumber,
    normalizeAustralianPhoneNumber,
  };

  global.BFFPhoneValidation = helpers;

  if ( typeof module !== 'undefined' && module.exports ) {
    module.exports = helpers;
  }
})(typeof window !== 'undefined' ? window : globalThis);
